/**
 * Phase 6+ — `/` route content is empty.
 *
 * The TanStack route component renders inside the `<Outlet />` of
 * `__root.tsx`, which itself sits inside `<Win95Desktop>`. The
 * desktop is the *only* visual on `/` — icons, taskbar, start menu,
 * FirstRunTour, etc. — and it covers the full viewport.
 *
 * Anything rendered here would be hidden under the desktop chrome
 * (legacy h2 + p left over from pre-desktop days were dead code).
 * Keep this component as a deliberate no-op so the route stays
 * registered without showing invisible content.
 *
 * Search params:
 *   - `?onboard=auto` — set on Clerk sign-in/up redirect AND by the
 *     `__root.tsx` first-time-orientation gate. Win95Desktop's
 *     auto-open-wizard effect detects it on mount, opens the F18
 *     wizard window once, then scrubs the param via
 *     history.replaceState so refresh doesn't re-trigger.
 */
import { createFileRoute } from '@tanstack/react-router';

// Exported so TanStack's generated routeTree.gen.ts can name the
// inferred search-param type on the Route's exported binding.
export interface HomeSearch {
  onboard?: 'auto';
}

export const Route = createFileRoute('/')({
  component: HomePage,
  validateSearch: (search: Record<string, unknown>): HomeSearch => ({
    onboard: search.onboard === 'auto' ? 'auto' : undefined,
  }),
});

function HomePage(): null {
  return null;
}
